import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

import { RouteCacheController } from './route-cache-controller';

@Injectable()
export class UIRouteReuseStrategy implements RouteReuseStrategy {
  private caches: { [key: string]: Array<DetachedRouteHandle> } = {};

  private isCache: boolean = false;
  private routeSequence: Array<string> = [];

  private static getRouteIdentifier(route: ActivatedRouteSnapshot): string {
    const urls = [];

    if (route.routeConfig.loadChildren) {
      return UIRouteReuseStrategy.getRouteIdentifier(route.firstChild);
    }

    let r = route;
    while (r.firstChild) {
      r = r.firstChild;
    }
    while (r && r.routeConfig) {
      urls.unshift(r.routeConfig.path);
      r = r.parent;
    }
    return urls.join('/');
  }

  constructor(private routeCacheController: RouteCacheController) {
    this.routeCacheController.hasCache.subscribe(b => {
      this.isCache = b;
    });
  }

  // æ¯å¦ç¼å­è·¯ç±
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isCache;
  }

  // å­å¨è·¯ç±
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle) {
    const url = UIRouteReuseStrategy.getRouteIdentifier(route);
    if (handle) {
      this.routeSequence.push(url);
      if (!this.caches[url]) {
        this.caches[url] = [];
      }
      this.caches[url].push(handle);
      return;
    }
    const caches = this.caches[url];
    caches.pop();
    if (caches.length === 0) {
      delete this.caches[url];
    }
  }

  // æ¯å¦è¿åå½åè·¯ç±
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const url = UIRouteReuseStrategy.getRouteIdentifier(route);
    const lastUrl = this.routeSequence[this.routeSequence.length - 1];
    if (this.caches[url] && url === lastUrl) {
      this.routeSequence.pop();
      return true;
    }
    return false;
  }

  // åå¾ä¹åç¼å­çè·¯ç±
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {

    if (!route.routeConfig || this.isCache) {
      return null;
    }
    const url = UIRouteReuseStrategy.getRouteIdentifier(route);
    const caches = this.caches[url] || [];
    return caches[caches.length - 1];
  }

  // æ¯å¦éç¨è·¯ç±
  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === current.routeConfig;
  }
}
